import React, { useState } from 'react';
import { DownArrowIcon } from 'src/SharedComponents/Icons/Icons';
import './CountryDropdown.css';
import { ICountry } from 'src/Utils/Hooks/useCreateClinic/useGetClinicCountries';

interface CountryDropdownProps {
  countries: ICountry[];
  onChange: (country: ICountry) => void;
  defaultCountry: string;
}

const CountryDropdown: React.FC<CountryDropdownProps> = ({ countries, onChange, defaultCountry }) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [selectedCountry, setSelectedCountry] = useState<string>(defaultCountry);
  
  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleCountrySelect = (country: ICountry) => {
    setSelectedCountry(country.name);
    setIsOpen(false);
    onChange(country); // Call the onChange function with the selected country
  };

  return (
    <div style={{ position: 'relative', width: '100%' }}>
      <div
        onClick={toggleDropdown}
        className="country-dropdown"
      >
        {selectedCountry}
        <span style={{ transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.2s' }}>
          <DownArrowIcon />
        </span>
      </div>
      {isOpen && (
        <div className="country-dropdown-list">
          {countries.map((country) => (
            <div
              key={country.id}
              onClick={() => handleCountrySelect(country)}
              className={country.supported ? 'country-dropdown-list-item' : 'country-dropdown-list-item disabled'}
            >
              {country.name}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CountryDropdown;